import classNames from "classnames";
import React from "react";
import {
  GOVGR_ADMIN_SIDE_CONTENT,
  GOVGR_CLOSE_ICON,
  GOVGR_DRAWER_CONTENT,
  GOVGR_DRAWER_HEADER_CONTAINER,
  GOVGR_DRAWER_LEFT,
  GOVGR_DRAWER_SIDE,
  GOVGR_LIST,
  GOVGR_LIST_ITEM,
  GOVGR_SVG_ICON,
  GOVGR__DRAWER_CLOSE_ICON,
} from "../../conf/styles/GovGrDrawerMenu";

const SideBarWithItems = ({
  hiddenicon,
  closemenu,
  ismenuformobileopen,
  menucomponent,
  hiddenmenu,
}) => {
  const svgCrossIconClassname = classNames(
    GOVGR__DRAWER_CLOSE_ICON,
    GOVGR_CLOSE_ICON,
    GOVGR_SVG_ICON,
    { hidden: hiddenicon }
  );

  const SideBarMenuWrapper = classNames(
    GOVGR_ADMIN_SIDE_CONTENT,
    "md:col-span-2",
    "flex",
    {
      hidden: hiddenmenu || ismenuformobileopen,
    }
  );

  return (
    <div className={SideBarMenuWrapper}>
      <div className={`${GOVGR_DRAWER_LEFT} ${GOVGR_DRAWER_SIDE}`}>
        <div className={`${GOVGR_DRAWER_CONTENT} max-h-[65vh]`}>
          <div className={GOVGR_DRAWER_HEADER_CONTAINER}>
            <svg
              className={svgCrossIconClassname}
              focusable="false"
              viewBox="0 0 24 24"
              aria-hidden="true"
              onClick={closemenu}
            >
              <polygon points="14.4,11.8 22,4.2 19.7,1.8 12,9.4 4.4,1.8 2,4.2 9.7,11.9 2.1,19.5 4.4,21.9 12.1,14.3 19.7,21.9 22.1,19.5 "></polygon>
            </svg>
          </div>
          <div className="h-max overflow-y-auto">
            {menucomponent ? (
              menucomponent
            ) : (
              <ul className={GOVGR_LIST}>
                <li className={GOVGR_LIST_ITEM}>Menu option 1</li>
                <li className={GOVGR_LIST_ITEM}>Menu option 2</li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBarWithItems;
